import React, { useContext,useEffect } from 'react'
import {dataContext,toText,localestr,loaddat,beginYr} from '../utils.js'
import UniTreeTable from '../cmp/UniTreeTable.js'
import FilterForm from '../cmp/FilterForm.js' //+
import Menu from '../cmp/menu.js'
import icon from '../icons.svg'

let findDlg=false

function CatCounterpartiesList({data=undefined,actions,choice=false}){

    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabNew=actions.tabNew
    const tabClose=actions.tabClose
    const tabChoice=actions.tabChoice
    const tblPos=actions.tblPos  //Таблиця
    const isActive=actions.isActive  //Таблиця
    const setGlData=actions.setGlData
    const getGlData=actions.getGlData

    if(wndData!==''&&wndData.ierarc===undefined) wndData.ierarc=1

    const context=useContext(dataContext)
    const Data=context.data['catCounterparties']
    const DataFld=context.data['fldCounterparties']
    const getData=context.getData
    const saveData=context.saveData
    const updateData=context.updateData
    const msg=context.msg
    const getSettings=context.getSettings
    const setSettings=context.setSettings
    const usersettings=getSettings()
    const inputCols=context.inputCols
    const setLoginData=context.setLoginData
    const glStatus=context.status
    let balance=undefined
    if(wndData) balance=wndData.balance
    let hiden=true
    if(wndData.hiden!==undefined) hiden=wndData.hiden

    const cols=[
        {caption:'icon',minWidth:'20',dataId:'catContr',sortable:false},
        {caption:'id',minWidth:'15',dataId:'id',sortable:true},
        {caption:localestr('Назва'),minWidth:'160',dataId:'name',sortable:true},
        {caption:localestr('ЄДРПОУ'),minWidth:'32',dataId:'okpo',sortable:true},
        {caption:localestr('Телефон'),minWidth:'32',dataId:'tell',sortable:true},
        {caption:localestr('Борг'),minWidth:'32',maxWidth:'75',dataId:'sum_bal',sortable:true},
    ]

    if(usersettings.CatCounterpartiesList&&usersettings.CatCounterpartiesList.cols){
        for(let i=0;i<usersettings.CatCounterpartiesList.cols.length;i++){
            const idx=cols.findIndex(el=>el.dataId===usersettings.CatCounterpartiesList.cols[i])
            if(idx!==-1) cols[idx].hiden=true
        }
    } else {
        cols[3].hiden=true
    }

    const filterData=[ //+
        {caption:'№',dataId:'id',typeVal:'text'},
        {caption:localestr('Назва'),dataId:'name',typeVal:'text'},
        {caption:localestr('ЄДРПОУ'),dataId:'okpo',typeVal:'text'},
        {caption:localestr('Телефон'),dataId:'tell',typeVal:'text'},
        {caption:localestr('Адреса'),dataId:'address',typeVal:'text'},
        {caption:localestr('Борг'),dataId:'sum_bal',typeVal:'number'},
        {caption:localestr('Примітка'),dataId:'note',typeVal:'text'},
    ]

    const setFilter=(id,val,type)=>{
        let filter=[...(wndData.filter||[])]
        const idx=filter.findIndex(el=>el.dataId===id)
        if(idx!==-1){
            if(!val) filter.splice(idx,1)
            else filter[idx].value=val
        } else if(val) filter.push({dataId:id, compare:'lk', value:val, typeVal:type})
        if (!filter.length) filter=undefined
        setWndData({...wndData,filter,currentCol:undefined})
        setGlData({needFocus:1})
        tblPos(0)
    }

    const showHideFilter=()=>{
        const showAFilter=!wndData.showAFilter
        let ierarc=1
        if(showAFilter) ierarc=0
        //if(ierarc!==wndData.ierarc) msg(ierarc?localestr('Режим відображення було змінено на показ папок'):localestr('Режим відображення було змінено на показ списку'),localestr('Попередження'),[{caption:'OK',action:()=>{}}])
        if(!showAFilter) setWndData({...wndData,ierarc,filter:undefined,showAFilter})
        else setWndData({...wndData,ierarc,showAFilter})
    }

    const listFromData=(currentCol,setCurrCol)=>{
        let list=[]
        let balance=[]
        if(wndData.balance) balance=wndData.balance
        if (typeof Data !== 'undefined') list=Data.map((item)=>{
            const newItem={...item}
            const idx=balance.findIndex(x => x.counterpartie === parseInt(item.id))
            if(idx!==-1) {
                newItem.sum_bal=balance[idx].sum===0?'':balance[idx].sum.toFixed(2)
            }
            if (typeof currentCol !== 'undefined' && currentCol.id===item.id) setCurrCol(newItem)
            return newItem})
        return list
    }

    const sortList=(col,sort,list)=>{
        let needUpd=false
        let currentCol=wndData.currentCol
        if (typeof list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else if (typeof wndData.list === 'undefined') {list=listFromData(currentCol,newCol=>currentCol=newCol);needUpd=true} 
        else list=wndData.list.slice()

        list.sort((a,b)=>{
            let vala=toText(a[col])
            let valb=toText(b[col])
            if(col==='id'){
                vala=parseInt(vala)
                valb=parseInt(valb)
            } else if(col.substring(0,4)==='sum_') {
                vala=parseFloat(a[col]||0)
                valb=parseFloat(b[col]||0)
            } else {
                vala=vala.toLowerCase()
                valb=valb.toLowerCase()
            }
            if (sort==='asc') {
                if (vala < valb) {needUpd=true;return -1}
                if (vala > valb) return 1
                return 0
            } else if (sort==='desc'){
                if (vala < valb) return 1
                if (vala > valb) {needUpd=true;return -1}
                return 0
            } else return 0
        })
        const sorting={dataId:col,sort:sort}
        if (needUpd || wndData.sorting.dataId!==col || wndData.sorting.sort!==sort) 
        setWndData({...wndData,list,sorting,currentCol})
    }

    const setHidenCols=(data)=>{
        if(data){
            const new_data=data.filter(el=>el.hiden).map(el=>el.dataId)
            setSettings({CatCounterpartiesList:{cols:new_data}})
        } else {
            inputCols(cols,setHidenCols)
        }
    }

    const newItem=()=>{tabNew('catCounterparties_edit',localestr('Контрагент')+' *',{parent:wndData.currentFld,update:after_save})}

    const editItem=()=>{
        if (typeof wndData.currentCol === 'object') {
            if(wndData.currentCol.isfolder) tabNew('fldCounterparties_edit',localestr('Папка')+' '+toText(wndData.currentCol['name']),{...wndData.currentCol,update:after_save})
            else tabNew('catCounterparties_edit',localestr('Контрагент')+' '+toText(wndData.currentCol['name']),{...wndData.currentCol,update:after_save})
            //console.log(wndData.currentCol)
        }
    }

    const copyItem=()=>{
        let item={...wndData.currentCol}
        delete item.id
        if (typeof wndData.currentCol === 'object') {
            if(wndData.currentCol.isfolder) tabNew('fldCounterparties_edit',localestr('Папка')+' *',{...item,update:after_save})
            else tabNew('catCounterparties_edit',localestr('Контрагент')+' *',{...item,update:after_save})
            //console.log(wndData.currentCol)
        }
    }

    const fldClick=(fld,ch=1)=>{
        //console.log('fldClick')
        if(!wndData.currentFld) setWndData({...wndData,currentFld:fld})
        else if(wndData.currentFld.id===fld.id&&ch===0) setWndData({...wndData,currentFld:fld.parent})
        else setWndData({...wndData,currentFld:fld,currentCol:undefined})
        setGlData({needFocus:0})
    }

    const editClick=()=>{
        if (typeof wndData.currentCol === 'object') {
            if(wndData.currentCol.isfolder) fldClick(wndData.currentCol,0)
            else if(choice===2) {tabChoice(wndData.currentCol)}
            else if(choice) {tabChoice(wndData.currentCol);tabClose()}
            else editItem()
        }
    }
            
    const getNextItem=(i,d)=>{
        if(d>0) for(let idx=i+1;idx<wndData.list.length;idx++) if(!parseInt(wndData.list[idx].marked)&&wndData.list[idx].parent.id===wndData.currentFld.id) return ({...wndData.list[idx]})
        else for(let idx=i-1;idx>=0;idx--) if(!parseInt(wndData.list[idx].marked)&&wndData.list[idx].parent.id===wndData.currentFld.id) return ({...wndData.list[idx]})

        return undefined
    }

    const removeItem=()=>{
        if (typeof wndData.currentCol === 'object') {
            const idx=wndData.list.findIndex(el=>el.id===wndData.currentCol.id)
            let item=undefined
            if(hiden&&idx+1>=wndData.list.length&&idx>0) item=getNextItem(idx,-1)
            else if(hiden&&idx>0) item=getNextItem(idx,1)
            else if(idx!==-1) item={...wndData.list[idx]}
            let newData={status:'rem',key:(wndData.currentCol.isfolder?'FldCounterparties':'CatCounterparties'),data:{id:wndData.currentCol.id,marked:(wndData.currentCol.marked==='0'?'1':'0')}}
            saveData(newData,()=>{setWndData({...wndData,currentCol:item})})
        }
    }

    const transferItem=(item,target)=>{
        if (typeof item === 'object') {
            let newData={status:'mod',key:(item.isfolder?'FldCounterparties':'CatCounterparties'),data:{...item,parent:target}}
            saveData(newData,()=>{})
        }
    }
    
    const setCol=(currentCol)=>{
        //const list=wndData.list
        //const sorting=wndData.sorting
        setWndData({...wndData,currentCol,currentFld:currentCol.parent})
        setGlData({needFocus:0})
    }

    const filter=(fltr)=>{
        let showFilter=!wndData.showFilter
        let filter=wndData.filter
        if (fltr!==undefined) filter=fltr
        let ierarc=1
        if(fltr) ierarc=0
        if(showFilter) ierarc=wndData.ierarc
        //if(ierarc!==wndData.ierarc) msg(ierarc?localestr('Режим відображення було змінено на показ папок'):localestr('Режим відображення було змінено на показ списку'),localestr('Попередження'),[{caption:'OK',action:()=>{}}])
        if(showFilter || fltr===undefined) setWndData({...wndData,showFilter,filter,ierarc})
        else{
            setWndData({...wndData,showFilter,filter,ierarc,currentCol:undefined})
            setGlData({needFocus:1})
            tblPos(0)
        }
    }

    const clrCatalog=(noQuestions)=>{
        if(noQuestions){
            let newData={status:'clr',key:'catCounterparties'}
            saveData(newData,()=>{})
        }
        else msg(localestr('Буде видалено позначені елементи без\nможливості відновлення! Продовжити?'),localestr('Попередження'),[{caption:'OK',action:()=>{clrCatalog(true)}},{caption:localestr('Відміна'),action:()=>{}}])
    }

    const objHistory=()=>{
        if (typeof wndData.currentCol === 'object') {
            const type=wndData.currentCol.isfolder?'fldCounterparties':'catCounterparties'
            tabNew('repObjHistory',localestr('Історія змін')+' '+toText(wndData.currentCol['name']),{object:{...wndData.currentCol,type:type}},true)
        }
    }

    const loadData=(d)=>{
        if (d) {
            const status=d.status
            if(status==='UsrChoise') {setLoginData(d);return}
            if (status==='OffLine') {msg(localestr('Помилка з\'єднання'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            if (status==='error') {msg(d.msg,localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
            wndData=actions.getWndData()
            const list=wndData.list||[]
            list.forEach(item => {
                const idx=d.data.findIndex(x => x.counterpartie === parseInt(item.id))
                if(idx!==-1) {
                    item.sum_bal=d.data[idx].sum===0?'':d.data[idx].sum.toFixed(2)
                }
            })
            setWndData({...wndData,list,balance:d.data})
        } else {
            loaddat('action=balCredits',(dt)=>{loadData(dt)})
        }
    }

    const after_save=(d)=>{
        if(!d) return
        const currentCol={}
        currentCol.id=''+d.id
        if(d.isfolder) currentCol.isfolder=true
        wndData=actions.getWndData()
        let currentFld=wndData.currentFld
        if(d.parent) currentFld=DataFld.find(el=>el.id===d.parent.id)
        if (wndData && wndData.sorting) sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        else sortList('name','asc',undefined)
        //console.log({...wndData,currentCol,currentFld})
        setTimeout(()=>{setWndData({...wndData,currentCol,currentFld});setGlData({needFocus:0})},10)
        updateData('catCounterparties')
        loadData()
    }

    const tick=()=>{
        if (wndData.showFilter) return
        if (typeof Data === 'undefined') {setTimeout(()=>loadData(),300);return;}
        loadData()
    }

    const anyKey=(key)=>{
        if(key==='Delete') removeItem()
        else if(key==='Insert') newItem()
        else if(key==='shift_Insert') tabNew('fldCounterparties_edit',localestr('Папка')+' *')
        else if(key==='F9') copyItem()
        else if(key==='shift_F4') tabClose()
        else if(key==='F2') filter()
        //else console.log(key)
    }

    const hDragDrop=(item,target)=>{
        if(item.isfolder && item.id===target.id) return
        if(item.parent.id===target.id) return
        if(item.id===target.parent.id) return
        if(target.parent.parent) {
            if(item.id===target.parent.parent.id) return
            if(target.parent.parent.parent) {
                if(item.id===target.parent.parent.parent.id) return
                if(target.parent.parent.parent.parent) {
                    if(item.id===target.parent.parent.parent.parent.id) return
                    
                }
            }
        }
        msg('Перемістити '+item.name+' у '+target.name+'?',localestr('Переміщення'),[{caption:localestr('Так'),action:()=>{transferItem(item,target)}},{caption:localestr('Ні'),action:()=>{}}])
    }

    const needFocus=(reset=true)=>{   //Таблиця
        if(isActive()===false) return -1
        const glData=getGlData()
        const needFocus=glData.needFocus
        if(needFocus===undefined) return -1
        if(reset) setGlData({needFocus:-1})
        return needFocus
    }

    useEffect(() => {
        if(glStatus==='loading') return
        if(glStatus==='UsrChoise') return
        if (typeof Data === 'undefined') getData('catCounterparties')
        else if (wndData && wndData.sorting) sortList(wndData.sorting.dataId,wndData.sorting.sort,undefined)
        else sortList('name','asc',undefined)
    // eslint-disable-next-line 
    },[Data,DataFld,balance])
    
    useEffect(() => {
        if(glStatus==='loading') return
        if(glStatus==='UsrChoise') return
        if(wndData.currentCol&&choice) setGlData({needFocus:0})
        //console.log('effect2')
        tick()
        if(wndData.currentCol&&choice) setGlData({needFocus:0})
        const intervalHandle=setInterval(tick,30000)
        return () => clearInterval(intervalHandle)
    // eslint-disable-next-line 
    },[])

    const liability=()=>{
        if(choice) return
        if(!wndData.currentCol) return
        const to=new Date()
        if(wndData.currentCol && wndData.currentCol.isfolder){
            tabNew('repLiability',localestr('Звіт по заборгованості'),{
                filter:[{caption:'Контрагент',dataId:'counterpartie_id',typeVal:'catCounterparties',compare:'in_f',value:wndData.currentCol}],
                grouping:[{name:'Контрагент',value:'counterpartie_id',checked:true,type:'catCounterparties'},
                {name:'Група',value:'folder_id',checked: false,type: 'fldCounterparties'},
                {name: 'Документ',value: 'doc_id',checked: true,type:'document',disable_move: true }],
                from:beginYr(to),to:to,run:true
            },true)
        } else {
            tabNew('repLiability',localestr('Звіт по заборгованості'),{
                filter:[{caption:'Контрагент',dataId:'counterpartie_id',typeVal:'catCounterparties',compare:'=',value:wndData.currentCol}],
                grouping:[{name:'Контрагент',value:'counterpartie_id',checked:false,type:'catCounterparties'},
                {name:'Група',value:'folder_id',checked: false,type: 'fldCounterparties'},
                {name: 'Документ',value: 'doc_id',checked: true,type:'document',disable_move: true }],
                from:beginYr(to),to:to,run:true
            },true)
        }
    }


    const wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
    const wndDataFld = typeof DataFld === 'undefined' ? [] : DataFld
    const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
    const showFilter = wndData.showFilter ? <FilterForm filterData={filterData} filter={wndData.filter} setFilter={filter}/> : ''  //+
    const ierarcBtn = wndData.ierarc ? <div  tabIndex='0' className='toolBarItem' title={localestr('Показувати список')}  
                                    onClick={()=>{setWndData({...wndData,ierarc:0})}} onKeyUp={(e)=>{if(e.key === 'Enter') setWndData({...wndData,ierarc:0})}}
                                    ><img src={icon+'#foldBut'} alt={localestr('Показувати список')} /></div> : 
                                    <div  tabIndex='0' className='toolBarItem' title={localestr('Показувати папки')}  
                                    onClick={()=>{setWndData({...wndData,ierarc:1})}} onKeyUp={(e)=>{if(e.key === 'Enter') setWndData({...wndData,ierarc:1})}}
                                    ><img src={icon+'#unfoldBut'} alt={localestr('Показувати папки')} /></div>

    const menuData=[
        {name:localestr('Налаштування таблиці'),icon:'#b953',action:setHidenCols},
        {name:localestr('Фільтр'),icon:'#b955',action:filter},
        {name:localestr('Друк списку'),icon:'#b503',action:()=>{window.print()}},
        {name:localestr('Історія змін'),icon:'#b505',action:objHistory},
        {name:localestr('Остаточне видалення'),icon:'#remBut',action:clrCatalog},
        {name:localestr('Оновити список'),icon:'#b954',action:()=>{updateData('catCounterparties')}},
        //{name:localestr('Групова зміна'),icon:'#hisBut',action:grpEdit},
    ]
    if(choice) menuData.splice(2,3)
    let btn3=null
    if(!choice&&wndData.currentCol) btn3=<div tabIndex='0' onClick={()=>liability()} onKeyUp={(e)=>{if(e.key === 'Enter') liability()}}
    style={{alignSelf:'center',lineHeight:'30px',height:'30px',width:'95px',padding:'0px 2px 0 6px',textAlign:'center',userSelect:'none',cursor:'pointer',color:'#FFF',background:'url('+icon+'#btn95v) no-repeat',backgroundSize:'102px 30px'}}>
    {localestr('Акт звірки')}
    </div>


    const findItem=(val)=>{
        const newData={...wndData,findText:val}
        findDlg=false
        newData.findArr=null
        if (val.length>1){
            const Arr=wndData.list.filter(el=>(el.id.indexOf(val)===0||(el.name||'').toLowerCase().indexOf(val.toLowerCase())!==-1||(el.barcode&&el.barcode.indexOf(val)===0))&&!parseInt(el.marked))
            if(Arr.length>10) Arr.splice(10)
            newData.findArr=Arr
            if(Arr.length) findDlg=true
            else{newData.findArr=null;findDlg=false}
        }
        setWndData(newData)
    }

    const findClick=(el)=>{
        const wndData_=actions.getWndData()
        const newData={...wndData_,currentCol:{...el},currentFld:{...el.parent},findText:'',findArr:null,currFind:-1}
        findDlg=false
        setWndData(newData)
        setGlData({needFocus:0})
    }

    const keyHandler=(e)=>{
        if(e.key==='ArrowUp'&&wndData.findArr) {
            if(wndData.currFind===undefined||wndData.currFind===-1) setWndData({...wndData,currFind:0})
            else if(wndData.currFind===0) setWndData({...wndData,currFind:wndData.findArr.length-1})
            else setWndData({...wndData,currFind:wndData.currFind-1})
        }
        else if(e.key==='ArrowDown'&&wndData.findArr) {
            if(wndData.currFind===undefined||wndData.findArr.length-1<=wndData.currFind) setWndData({...wndData,currFind:0})
            else setWndData({...wndData,currFind:wndData.currFind+1})
        }
        else if(e.key==='Enter'&&wndData.findArr&&wndData.currFind!==-1) {
            if(wndData.currFind===-1) findClick(wndData.findArr[0])
            else findClick(wndData.findArr[wndData.currFind])
        }
    }

    let findItems=null
    if(findDlg&&wndData.findArr){
        setTimeout(()=>findDlg=false,30000)
        const items=wndData.findArr.map((el,idx)=>{
            let stl={cursor:'pointer',fontSize:'small'}
            if(idx===wndData.currFind) stl.background='#9E91F7'
            return(
            <div key={idx} style={stl} onClick={()=>{findClick(el)}}>{el.id+' - '+el.name}</div>
        )})
        findItems=<div className='no-print' style={{right:'0px',top:'24px',width:'100%',position:'absolute',background:'#FFFFFF',zIndex:'100'}}>
            {items}
        </div>
    }

    return(
        <>
        
        <div style={{display:'flex',flexDirection:'column',height:'calc(100% - 3px)'}}>
        <div className='toolBar no-print'>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Додати')+' (Ins)'} 
            onClick={newItem}
            onKeyUp={(e)=>{if(e.key === 'Enter') tabNew('catCounterparties_edit',localestr('Контрагент')+' *')}}><img src={icon+'#addBut'} alt={localestr('Додати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Додати папку')+' (Shift+Ins)'} 
            onClick={()=>{tabNew('fldCounterparties_edit',localestr('Папка')+' *',{parent:wndData.currentFld,update:after_save})}}
            onKeyUp={(e)=>{if(e.key === 'Enter') tabNew('fldCounterparties_edit',localestr('Папка')+' *',{parent:wndData.currentFld,update:after_save})}}><img src={icon+'#fldBut'} alt={localestr('Додати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Редагувати')} 
            onClick={editItem} onKeyUp={(e)=>{if(e.key === 'Enter') editItem()}}
            ><img src={icon+'#editBut'} alt={localestr('Редагувати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Копіювати')+' (F9)'} 
            onClick={copyItem} onKeyUp={(e)=>{if(e.key === 'Enter') copyItem()}}
            ><img src={icon+'#copyBut'} alt={localestr('Копіювати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Видалити')+' (Del)'}
            onClick={removeItem} onKeyUp={(e)=>{if(e.key === 'Enter') removeItem()}}
            ><img src={icon+'#delBut'} alt={localestr('Видалити')} /></div>
            <div  tabIndex='0' className='toolBarSeparator'></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Автофільтр')}  
            onClick={()=>{showHideFilter()}} onKeyUp={(e)=>{if(e.key === 'Enter') showHideFilter()}}
            ><img src={icon+'#filtBut'} alt={localestr('Автофільтр')} /></div>
            {ierarcBtn}
            <div  tabIndex='0' className='toolBarSeparator'></div>
            <div style={{position:'relative',padding:'3px'}}>
                <input id='search' type='text' value={wndData.findText||''} onChange={(e)=>{findItem(e.target.value)}}  onKeyUp={keyHandler}
                    onBlur={()=>{setTimeout(()=>{if(findDlg) setWndData({...wndData,findArr:null,currFind:undefined})},200)}} placeholder={localestr('пошук')} 
                    style={{width:'calc(100% - 28px)',padding:'0 22px 0 2px',flexShrink:'0',fontSize:'inherit',fontFamily:'inherit'}} />
                <img src={icon+'#b956'} alt='' style={{position:'absolute',right:'7px',top:'9px',width:'14px',height:'14px',opacity:0.5}}/>
                {findItems}
            </div>
            <div style={{flexGrow:'10'}}></div>{btn3}
            <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
                <img className='toolBarIcon' src={icon+'#dnBut'} alt='' />
            </Menu></div>
        </div>
        <UniTreeTable haveHeader={true} colsArr={cols} data={wndDataList} folders={wndDataFld} ierarc={wndData.ierarc} currCol={wndData.currentCol} currFld={wndData.currentFld} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} Caption={localestr('Контрагенти')} clickSort={sortList} clickHandle={(item)=>{setCol(item)}} fldHandle={fldClick} openHandle={editClick} keyHandle={anyKey} hDragDrop={hDragDrop} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus} isActive={isActive()}/>
        </div>
        {showFilter}
        </>
    )
    
}

export default CatCounterpartiesList